// A sheet as everyone but its owner reads it: the rows that were answered, under their sections.

import { Fragment } from 'react';

import { displayRow } from './rows.js';

export default function SheetView({ sections, sheet }) {
  const answered = sections
    .map((section) => ({
      title: section.title,
      rows: section.rows
        .map((row) => ({ row, shown: displayRow(row, sheet[row.name]) }))
        .filter(({ shown }) => shown),
    }))
    .filter((section) => section.rows.length > 0);

  if (answered.length === 0) return <p className="muted">Nothing has been recorded.</p>;

  return answered.map((section) => (
    <div key={section.title} className="credit-section">
      <h4>{section.title}</h4>
      <dl className="deal-fields">
        {section.rows.map(({ row, shown }) => (
          <Fragment key={row.name}>
            <dt>{row.label}</dt>
            <dd>{shown}</dd>
          </Fragment>
        ))}
      </dl>
    </div>
  ));
}
